import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title1" }
const _hoisted_2 = { style: {"margin-left":"10px"} }

export function render(_ctx, _cache) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      type: "flex",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title2" }, null, -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text), 1),
        (_ctx.tip)
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              content: _ctx.tip,
              placement: "bottom",
              effect: "light"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", {
                  class: "el-icon-question",
                  style: {"color":"#C0C4CC","margin-left":"5px","cursor":"pointer"}
                }, null, -1)
              ])),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}